import React, { useEffect } from 'react';
import styles from './procedimentos_amandacgazoni.module.scss';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const procedimentos = [
    "Toxina Botulínica",
    "Bioestimulador de Colágeno",
    "Fios de Sustentação",
    "Microagulhamento",
    "PDRN",
    "Exossomos",
    "Preenchimento de Ácido Hialurônico",
    "Enzimas",
    "PEIM",
    "Hidrolipoclasia"
];

const Procedimentos_amandacgazoni: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.procedimentos_amandacgazoni}>
            <div className={styles.header}>
                <Link to="/amandacgazoni" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1>Procedimentos</h1>
            </div>

            <div className={styles.listContainer}>
                {procedimentos.map((item, index) => (
                    <div key={index} className={styles.procedimentoItem}>
                        <h3>{item}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Procedimentos_amandacgazoni;
